const Filter = () => {
    return (
        <svg style={{ width: 0, height: 0 }}>
            <defs>
                <filter id='gooey'>
                    <feGaussianBlur
                        in='SourceGraphic'
                        stdDeviation='10'
                        result='blur'
                    />
                    <feColorMatrix
                        in='blur'
                        mode='matrix'
                        values='1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -8'
                        result='gooey'
                    />
                    <feBlend in='SourceGraphic' in2='gooey' />
                </filter>
            </defs>
        </svg>
    );
};

export default Filter;
